import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { MDBBtn } from "mdbreact";

import { connect } from 'react-redux';
import { SetMarcaEnAPI, GetNoticiasEnAPI, ObtenerEndPoint } from "../../action/actionCreatorsRequests";
import { MSGERROR, MSGOK, traducirPagina, obtenerToken, verificarExtension } from "../../librerias/funciones"
import {
    CloseOutlined,
    EyeOutlined,
    ShareAltOutlined,
    HeartOutlined
} from '@ant-design/icons';
import { Select, Card, Drawer, Input, Checkbox, Row, Col, Tabs } from 'antd';


import store from '../../store'
import VisorGenerico from '../VisorGenerico';
const { Option } = Select;
const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;

const FichaDetalleNoticia = ({ props }) => {
    const [hayLicencias, seHayLicencias] = React.useState(false);

    const [abrirVisor, setAbrirVisor] = React.useState(false);
    const [ficheroSeleccionado, setFicheroSeleccionado] = React.useState({});
    const [noticias, setNoticias] = React.useState([]);
    const { DESTACADA,
        ENVIADA,
        ESTADO_NOTICIA,
        EXTENSION,
        FECHA,
        FECHA_PUBLICACION,
        ID,
        ID_ESTADO_NOTICIA,
        ID_NOTICIA_TIPO,
        IMAGEN_BYTES,
        IMAGEN_CONTENT_TYPE,
        IMAGEN_NOMBRE,
        KEYWORDS,
        NUMERO,
        TEXTO,
        TEXTO_LIMPIO,
        TIPO_NOTICIA,
        TITULO,
        DOCUMENTOS,
        NOMBRE_CATEGORIAS
    } = noticias === undefined || noticias === null || noticias.length === 0 ? {} : noticias[0];



    const GetNoticias = (ORDERCOLUM, ORDERDIR, ID, FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA) => {
        GetNoticiasEnAPI(ORDERCOLUM, ORDERDIR, ID, FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA).then((registros) => {
            if (registros !== undefined && registros !== null && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setNoticias(registros.REGISTROS)
            } else {
                setNoticias(null)

            }
        })
    }


    if (!hayLicencias && props.ABRIR_FICHA) {
        seHayLicencias(true)
        GetNoticias(1, "A", props.REGISTRO_SELECCIONADO.ID, null, null, null)

    } else {
        if (!props.ABRIR_FICHA && hayLicencias) {

            seHayLicencias(false)
        }
    }


    const obtenerImagenPorExtension = (EXTENSION) => {
        EXTENSION = EXTENSION === undefined ? "" : EXTENSION.toUpperCase();
        let resultado = "";

        switch (EXTENSION) {
            case "PNG": case "JPG": case "JPEG": case "GIF":
                resultado = "imagen.png";
                break;
            case "PDF":
                resultado = "pdf.png";
                break;
            case "XLSX": case "XLSM": case "XLSB": case "XLTX": case "CSV": case "XLS":
                resultado = "excel.png"
                break;
            case "DOCX": case "DOC":
                resultado = "word.png"
                break;
            case "MP4": case "MOV": case "WMV": case "MKV":
                resultado = "video.png"
                break;
            case "ZIP": case "RAR":
                resultado = "comprimido.png"
                break;
            default:
                resultado = "generico.png"
                break;

        }
        return resultado;
    }


    const obtenerDocumento = (REGISTRO) => {
        setFicheroSeleccionado({})

        const { ID, EXTENSION, NOMBRE } = REGISTRO;
        const TIPO = obtenerImagenPorExtension(EXTENSION);

        if (TIPO === "imagen.png" || TIPO === "pdf.png") {
            setFicheroSeleccionado({ TITULO: NOMBRE === undefined || NOMBRE === null ? "VISTA PREVIA" : NOMBRE, TIPO_DOCUMENTO: TIPO === "imagen.png" ? "IMG" : "DOC", URL: `${ObtenerEndPoint()}api/NextGroup/VisualizarNoticiaDocumento/${props.REGISTRO_SELECCIONADO.ID}/${ID}/${window.btoa(obtenerToken())}`, FICHERO: {}, ID: ID })
            setAbrirVisor(true)
        } else {
            window.open(`${ObtenerEndPoint()}api/NextGroup/DescargaNoticiaDocumento/${props.REGISTRO_SELECCIONADO.ID}/${ID}/${window.btoa(obtenerToken())}`, '_blank').focus();
        }
    }



    const descargarFichero = (ID) => {
        window.open(`${ObtenerEndPoint()}api/NextGroup/DescargaNoticiaDocumento/${props.REGISTRO_SELECCIONADO.ID}/${ID}/${window.btoa(obtenerToken())}`, '_blank').focus();
    }

    return (
        <>
            <Drawer
                width={600}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ABRIR_FICHA}
                placement={"right"}
                closable={false}
                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}>
                

                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined>
                        <div> {props.title}</div>
                    </div>
                </div>

                <div className="container_detalle_noticia">
                    <div className='container_item_detalle'>
                        <div className="header_noticia">

                            <div className="Detalle_container_footer_noticia">
                                <div>
                                    <HeartOutlined></HeartOutlined>
                                    <ShareAltOutlined></ShareAltOutlined>
                                </div>

                                <div style={{ fontSize: '16px', color: '#000' }}>
                                    <span className="text_primary_noticia" style={{ fontSize: '18px' }}> {traducirPagina("Fecha")}:</span>
                                    {FECHA}

                                    <span className="text_primary_noticia" style={{ fontSize: '18px' }}> {traducirPagina("Publicada_el")}:</span>
                                    {FECHA_PUBLICACION}
                                </div>
                            </div>
                        </div>

                        <div className="body_noticia">

                            <h1>{TITULO}</h1>

                            {IMAGEN_CONTENT_TYPE === undefined ?
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div className={"skeleton-box"} style={{ height: '200px', width: '50%' }} > </div>
                                </div>
                                :
                                IMAGEN_CONTENT_TYPE === "" ?
                                    <img loading="lazy" src={"./imagenes/sinimagen.jpg"} style={{ height: '200px', width: 'unset' }}></img>

                                    :
                                    <img loading="lazy" src={`data:${IMAGEN_CONTENT_TYPE};base64,${IMAGEN_BYTES}`}></img>
                            }

                            <div className="foter_noticia">
                                {NOMBRE_CATEGORIAS !== undefined ?
                                    <ul>
                                        {NOMBRE_CATEGORIAS.split(";").map((registro) =>
                                            <li className="estiloCategorias">
                                                {registro}
                                            </li>
                                        )}
                                    </ul>
                                    :
                                    null
                                }
                            </div>


                            <div className='contenedor_img_Noticia'>
                                {DOCUMENTOS === undefined || DOCUMENTOS === null ?
                                    null
                                    :

                                    DOCUMENTOS.map((registro, i) =>
                                        <div className="item_documento_noticia" onClick={() => { obtenerDocumento(registro) }}>
                                            <div>
                                                {registro.NOMBRE === "" ? "" : `${registro.NOMBRE}.${registro.EXTENSION}`}
                                            </div>

                                            <div>
                                                <img loading="lazy" src={`./imagenes/iconos/${obtenerImagenPorExtension(registro.EXTENSION)}`}></img>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>


                            <div className="texto_noticia" dangerouslySetInnerHTML={{ __html: TEXTO }}>
                            </div>

                            <div className="foter_noticia">
                                <ul>
                                    <li className="estiloCategorias">
                                        {TIPO_NOTICIA}
                                    </li>
                                </ul>


                            </div>
                        </div>
                    </div>

                </div>
            </Drawer>

            {abrirVisor ?
                <VisorGenerico
                    title={""}
                    ABRIR_VISOR={abrirVisor}
                    CERRAR_VISOR={setAbrirVisor}

                    PROPIEDADES_DOC={ficheroSeleccionado}
                    MOSTRAR_BOTON_DESCARGA={true}
                    EVENTO_DESCARGA={descargarFichero}
                >
                </VisorGenerico>
                :
                null
            }
        </>

    )
}

FichaDetalleNoticia.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    REGISTRO_SELECCIONADO: PropTypes.object

};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaDetalleNoticia);